import React, { Component, Fragment } from 'react';

import Button from '../../artzu-ui/src/Button';
import TextField from '../../artzu-ui/src/TextField';

import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';

import SubmitImage from './SubmitImage';
import PreviewImage from './PreviewImage';
import Footer from './FooterFixed';

import ScrollLock from 'react-scrolllock';
import EncourageScroll from '../EncourageScroll';

const UPDATE_USER = gql`
  mutation updateUser($userFields: UserAttributes!) {
    updateUser(userFields: $userFields) {
      errors {
        message
      }
    }
  }
`;
class UploadSSN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      ssn: '',
      src: '',
      ssnError: '',
      loading: false,
    };
  }

  toggleLoaded = () => this.setState({ loading: !this.state.loading });

  updateSrc = src => this.setState({ src });

  checkErrors = () => {
    const { ssn } = this.state;

    if (!ssn.match(/^\d{9}$/)) {
      this.setState({ ssnError: ssn ? 'Not a valid format.' : 'This is required.' });
    } else {
      this.setState({ ssn });
      this.updateUser(ssn);
      return true;
    }
  };

  updateUser = number => {
    this.props.client
      .mutate({
        mutation: UPDATE_USER,
        variables: {
          userFields: {
            ssn: number,
          },
        },
      })
      .then(() => {
        this.props.refetch();
      });
  };

  onNextClick = () => {
    if (this.checkErrors()) this.props.incrementStep();
  };

  onBackClick = () => this.props.decrementStep();

  render() {
    const { currentUser, currentStep, refetch, title } = this.props;
    const { src, loading, ssn, ssnError } = this.state;

    return (
      <Fragment>
        <ScrollLock>
          <EncourageScroll className="apply__eligibility">
            <div className="apply__eligibility--container">
              <div className="apply__body--title"> {title}</div>
              <div className="apply__license--content">
                <TextField
                  onChange={evt => this.setState({ ssn: evt.target.value })}
                  heading="Social Security Number"
                  error={ssnError}
                  width="100%"
                  value={ssn}
                  placeholder="Enter SSN here"
                />
                <p style={{paddingTop: "1em"}}>Please provide your SSN. We will only use this for identity verification purposes.</p>
              </div>
             
            </div>
          </EncourageScroll>
        </ScrollLock>
        <Footer
          currentStep={currentStep}
          currentUser={currentUser}
          active={true}
          back
          label="Next"
          onNextClick={this.onNextClick}
          onBackClick={this.onBackClick}
        />
      </Fragment>
    );
  }
}

export default withApollo(UploadSSN);



// WEBPACK FOOTER //
// ./src/components/NycApply/UploadSSN.js